import { useTranslation } from 'react-i18next'

import { Card } from '../card/Card'

type LoadingProps = {
  // screen: centred on the viewport; inline: fills its container;
  // card: inline inside a card, so the card shell shows while content loads.
  variant?: 'screen' | 'inline' | 'card'
}

const Loading = ({ variant = 'screen' }: LoadingProps) => {
  const { t } = useTranslation('common')

  const loader = (
    <div
      className={`loading-state${variant === 'screen' ? '' : ' inline'}`}
      role="status"
      aria-live="polite"
    >
      <span className="loading-ball" aria-hidden="true">
        <svg viewBox="0 0 48 48">
          <defs>
            <clipPath id="loading-ball-clip">
              <circle cx="24" cy="24" r="21" />
            </clipPath>
          </defs>
          <g className="spin">
            <circle className="ball" cx="24" cy="24" r="21" />
            <g className="seams" clipPath="url(#loading-ball-clip)">
              <path d="M6 6c10 8 10 28 0 36" />
              <path d="M42 6c-10 8-10 28 0 36" />
            </g>
          </g>
          <circle className="shine" cx="17" cy="15" r="5" />
        </svg>
      </span>
      <span className="loading-shadow" aria-hidden="true" />
      <span className="visually-hidden">{t('loading')}</span>
    </div>
  )

  return variant === 'card' ? <Card>{loader}</Card> : loader
}

export default Loading
